import { useState } from 'react';
import PropTypes from 'prop-types';
import CustomCheckbox from '../atoms/custom-checkbox.atom';
import CustomText from '../atoms/custom-text.atom';
import PDFModal from '../templates/pdf-modal.template';

const AuthorizationForm = ({
    termsAccepted,
    onTermsAcceptedChange,
    privacyPolicyAccepted,
    onPrivacyPolicyAcceptedChange,
    creditReportAccepted,
    onCreditReportAcceptedChange
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    return (
        <div style={styles.container}>
            <div style={styles.checkboxContainer}>
                <CustomCheckbox
                    checked={termsAccepted}
                    onChange={onTermsAcceptedChange}
                />
                <CustomText variant="body" style={styles.label} onClick={() => {
                            setPdfUrl('https://beloz-public.s3.us-east-1.amazonaws.com/termsandconditions.pdf');
                            setIsModalOpen(true);
                        }}>
                    Acepto los{' '}
                    <CustomText 
                        variant="body" 
                        span 
                        style={styles.link}
                    >
                        Términos y Condiciones y cláusula de medios electrónicos
                    </CustomText>{' '}
                    tales como NIP
                </CustomText>
            </div>
            <div style={styles.checkboxContainer}>
                <CustomCheckbox
                    checked={privacyPolicyAccepted}
                    onChange={onPrivacyPolicyAcceptedChange}
                />
                <CustomText variant="body" style={styles.label}>
                    Acepto la <CustomText variant="body" span style={styles.link} onClick={() => {
                        setPdfUrl('https://beloz-public.s3.us-east-1.amazonaws.com/privacypolicy.pdf');
                        setIsModalOpen(true);
                    }}>Política de privacidad</CustomText>
                </CustomText>
            </div>
            <div style={styles.checkboxContainer}>
                <CustomCheckbox
                    checked={creditReportAccepted}
                    onChange={onCreditReportAcceptedChange}
                />
                <CustomText variant="body" style={styles.label} onClick={() => {
                    setPdfUrl('https://beloz-public.s3.us-east-1.amazonaws.com/Reportes+de+Cr%C3%A9dito.pdf');
                    setIsModalOpen(true);
                }}>
                    Autorización para solicitar <CustomText variant="body" span style={styles.link}>Reportes de Crédito</CustomText>
                </CustomText>
            </div>

            <PDFModal
                pdfUrl={pdfUrl}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title="Términos y Condiciones"
            />
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%'
    },
    checkboxContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        width: '100%'
    },
    link: {
        textDecoration: 'underline'
    }
};

AuthorizationForm.propTypes = {
    errors: PropTypes.object
};

export default AuthorizationForm;
